import type { DashboardSnapshot } from './types'
import { apiFetch } from '../../shared/http/apiFetch'

export async function getDashboard(signal?: AbortSignal): Promise<DashboardSnapshot> {
  const response = await apiFetch('/api/v1/dashboard', { signal, credentials: 'include' })
  if (!response.ok) {
    throw new Error('dashboard.loadError')
  }
  return response.json() as Promise<DashboardSnapshot>
}
